const useIsHappyFlow = () => true;
export default useIsHappyFlow;
